<div class="editor-wrapper">
    <input #input [(ngModel)]="inputValue" />
</div>
